<div class="info" *ngIf="comment">
  <div>
    {{comment?.text}}
  </div>
  <ion-button *ngIf="comment?.linkText" (click)="open(comment?.link)">{{comment?.linkText}}</ion-button>
</div>
